import { AlertBar, spacing6 } from '@leaftrade/leaftrade-component-library';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useStorefrontState } from '../../../hooks/useReduxState';
import PageLoader from '../../../shared/components/PageLoader';
import {
  getQuickOrderData,
  setSelectedQuickOrderLocations,
} from '../../../store/actions/storefrontActions';
import Breadcrumbs from '../../components/Breadcrumbs';
import QuickOrderHeader from '../../components/QuickOrderHeader';
import QuickOrderTable from '../../components/QuickOrderTable';
import AddToQuickOrderModal from '../../components/modals/AddToQuickOrderModal';
import ClearQuickOrderModal from '../../components/modals/ClearQuickOrderModal';
import DeleteQuickOrderItemModal from '../../components/modals/DeleteQuickOrderItemModal';

const QuickOrder = () => {
  const dispatch = useDispatch();
  const loadedQuickOrderSlugRef = useRef(null);
  const { quickOrderData, sellerPageData, shopper, vendor } =
    useStorefrontState();
  const { bannerText, bannerTitle } = sellerPageData;
  const { locations } = shopper;
  const {
    addToQuickOrderModal,
    clearQuickOrderModal,
    deleteItemModal,
    isLoadingQuickOrderData,
    selectedLocations,
  } = quickOrderData;
  const { slug } = vendor;

  useEffect(() => {
    if (!selectedLocations.length && locations.length) {
      dispatch(setSelectedQuickOrderLocations(locations));
    }
  }, [dispatch, locations, selectedLocations.length]);

  useEffect(() => {
    if (!selectedLocations.length || loadedQuickOrderSlugRef.current === slug) {
      return;
    }

    loadedQuickOrderSlugRef.current = slug;
    dispatch(
      getQuickOrderData({
        locationIds: selectedLocations.map(
          (selectedLocation) => selectedLocation.id
        ),
        slug,
      })
    );
  }, [dispatch, selectedLocations, slug]);
  return (
    <>
      <Breadcrumbs isQuickOrderPage />
      {bannerText && (
        <AlertBar
          animationIn={null}
          hideClose
          alertMessages={
            typeof bannerText === 'string' ? [bannerText] : bannerText
          }
          alertTitle={bannerTitle || ''}
          alertSeverity='info'
          sx={{
            marginTop: spacing6,
          }}
          testingId='quick-order--vendor-banner--alert-bar'
        />
      )}
      <QuickOrderHeader />
      {isLoadingQuickOrderData ? <PageLoader /> : <QuickOrderTable />}
      {addToQuickOrderModal.isOpen && <AddToQuickOrderModal />}
      {clearQuickOrderModal.isOpen && <ClearQuickOrderModal />}
      {deleteItemModal.isOpen && <DeleteQuickOrderItemModal />}
    </>
  );
};

export default QuickOrder;
